import React, {useCallback, useContext, useMemo, useState} from "react";
import {ConfigProvider, Switch} from "antd";
import "../../dashboards/DeliveryProviderDashboard/DeliveryProviderDeliveries/delivery-provider-deliveries.css";
import {DriverDeliveriesContext} from "./DriverDeliveriesContext.jsx";
import {TableDateRangeTable} from "../../components/OrdersDateRangeTable/TableDateRangeTable.jsx";
import {
    deliveriesPageSize,
    DeliveriesShortcuts,
    DeliveryShortcutsKeys
} from "../../dashboards/DeliveryProviderDashboard/DeliveryProviderDeliveries/consts.jsx";
import {columns} from "../../dashboards/DeliveryProviderDashboard/DeliveryProviderDeliveries/columns.jsx";
import {StringBuilder} from "../../AppUtils.js";

export const DriverDeliveries = ({history}) => {
    const {
        deliveries,
        isLoading,
        setCurrentPage,
        totalDeliveriesCount,
        currentPage,
        showDeliveredDeliveries,
        setShowDeliveredDeliveries
    } = useContext(DriverDeliveriesContext);

    const [searchInput, setSearchInput] = useState("");
    const filteredDeliveries = useMemo(
        () =>
            deliveries?.filter(({companyName, driverId, proposalId, price, order, destinationAddress}) =>
                [
                    companyName,
                    driverId,
                    String(proposalId),
                    String(price),
                    order.providerBrand,
                    destinationAddress?.city,
                    destinationAddress?.address
                ].some(property => property?.toLowerCase()?.includes(searchInput?.toLowerCase()))
            ),
        [searchInput, deliveries]
    );

    const handleShowDeliveredDeliveriesToggle = useCallback(checked => {
        setShowDeliveredDeliveries(prev => !prev);
    }, []);

    return (
        <div className="delivery-provider-deliveries-page">
            <ConfigProvider direction="rtl">
                <TableDateRangeTable
                    title={new StringBuilder("כמות משלוחים", " - ").append(`${totalDeliveriesCount ?? 0}`).toString()}
                    shortcutSearchOptions={DeliveriesShortcuts}
                    defaultShortcutSearchOptions={DeliveryShortcutsKeys.todayDeliveries}
                    allowDeselectShortcutSearchOptions={false}
                    tableClassName="delivery-provider-deliveries-table"
                    onInputSearch={value => setSearchInput(value)}
                    extraContent={
                        <div className="driver-deliveries-show-delivered-deliveries-toggle-container">
                            <Switch
                                onChange={handleShowDeliveredDeliveriesToggle}
                                checked={!showDeliveredDeliveries}
                                title={!showDeliveredDeliveries ? "משלוחים פתוחים" : "משלוחים סגורים"}
                            />
                            <span>{!showDeliveredDeliveries ? "משלוחים פתוחים" : "משלוחים סגורים"}</span>
                        </div>
                    }
                    pagination={{
                        position: ["bottomRight"],
                        showSizeChanger: false,
                        current: currentPage,
                        defaultPageSize: deliveriesPageSize,
                        total: totalDeliveriesCount,
                        showTotal: total => <span>סה״כ {total}</span>,
                        onChange: page => setCurrentPage(page)
                    }}
                    isLoadingOrderTable={isLoading}
                    data={filteredDeliveries ?? []}
                    showSearchByCreatedAt={false}
                    columns={columns(currentPage, [
                        {
                            title: "צפייה במשלוח",
                            onClick: ({deliveryId}) => history?.push(`/delivery/${deliveryId}`)
                        }
                    ])}
                    disableFutureDates={false}
                />
            </ConfigProvider>
        </div>
    );
};
